var _Clock;
import { useCallback } from "react";
import cn from "clsx";
import Level1 from "@crehana/compass.icons.fill/Level1";
import Level2 from "@crehana/compass.icons.fill/Level2";
import Level3 from "@crehana/compass.icons.fill/Level3";
import Clock from "@crehana/compass.icons.outline/Clock";
import { LazyImage } from "@crehana/compass.ui";
import { useCatalogEmptyStateTranslations } from "../../hooks";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var CourseCard = function CourseCard(_ref) {
  var title = _ref.title,
    coverImage = _ref.coverImage,
    level = _ref.level,
    duration = _ref.duration,
    href = _ref.href;
  var _useCatalogEmptyState = useCatalogEmptyStateTranslations(),
    t = _useCatalogEmptyState.t;
  var renderIconLevel = useCallback(function () {
    var _level = level.toLowerCase();
    var commonClasses = 'tw-fill-current tw-mr-0.4';
    var commonSize = 16;
    switch (_level) {
      case 'introductorio':
        return /*#__PURE__*/_jsx(Level1, {
          size: commonSize,
          className: commonClasses
        });
      case 'intermedio':
        return /*#__PURE__*/_jsx(Level2, {
          size: commonSize,
          className: commonClasses
        });
      case 'avanzado':
      case 'completo':
        return /*#__PURE__*/_jsx(Level3, {
          size: commonSize,
          className: commonClasses
        });
    }
  }, [level]);
  return /*#__PURE__*/_jsx("a", {
    href: href,
    children: /*#__PURE__*/_jsxs("article", {
      className: cn(
      // Flex
      'tw-flex tw-flex-col sm:tw-flex-row',
      // Padding
      'tw-py-0.8 tw-px-1.2',
      // Rounded
      'tw-rounded-1',
      // Border
      'tw-border tw-border-solid tw-border-transparent',
      // Hover
      'hover:tw-border-primary-light-400 dark:hover:tw-border-secondary-dark-500'),
      children: [/*#__PURE__*/_jsx(LazyImage, {
        src: coverImage,
        alt: title,
        className: cn(
        // Size
        'tw-w-full sm:tw-w-12 tw-h-8 tw-flex-none',
        // Rounded
        'tw-rounded-0.4',
        // Overflow
        'tw-overflow-hidden',
        // Margin
        'tw-mb-1.6 sm:tw-mb-0 sm:tw-mr-1.6'),
        imgClassName: "tw-object-cover tw-w-full tw-h-full",
        imgxParams: {
          w: 128,
          h: 80
        }
      }), /*#__PURE__*/_jsxs("div", {
        className: "tw-w-full",
        children: [/*#__PURE__*/_jsx("h5", {
          className: "tw-font-subtitle5 tw-line-clamp-1 tw-mb-0.8",
          children: title
        }), /*#__PURE__*/_jsxs("p", {
          className: "tw-flex tw-items-center tw-font-caption tw-mb-0.8 tw-text-neutral-light-700 dark:tw-text-neutral-dark-400",
          children: [renderIconLevel(), /*#__PURE__*/_jsx("span", {
            className: "tw-mr-1.2",
            children: level
          }), _Clock || (_Clock = /*#__PURE__*/_jsx(Clock, {
            size: 16,
            className: "tw-fill-current tw-mr-0.4"
          })), /*#__PURE__*/_jsx("span", {
            children: duration
          })]
        }), /*#__PURE__*/_jsx("span", {
          className: "tw-font-subtitle5 tw-text-primary-light-500 dark:tw-text-secondary-dark-500",
          children: t('CATALOG_EMPTY_STATE_COURSE_CARD_CTA')
        })]
      })]
    })
  });
};
export default CourseCard;